import { useSelector } from "react-redux";

/**
 * Single source of truth for the logged-in admin's role (GAP-018).
 *
 * ADMIN       — global super admin, sees every mall.
 * MALL_ADMIN  — scoped admin; the backend confines all their data to
 *               `managedMallId`, and the UI mirrors that scoping.
 */
export const useAdminRole = () => {
  const loginUser = useSelector((state) => state.user.loginUser);
  const role = loginUser?.role;

  return {
    role,
    isSuperAdmin: role === "ADMIN",
    isMallAdmin: role === "MALL_ADMIN",
    managedMallId: loginUser?.managedMallId ?? null,
  };
};
